module.exports = __webpack_public_path__ + "media/images/emblems/Trun_wappen-d87491d7b14a2580a96d46a07b30dd9c.svg";